import { AccountType as J, ButtonAlignment as H } from "@nextgen-web-framework/all";
import { _ as k, A as $, R as P, O as le } from "./profileEnums-fde613bf.mjs";
import { _ as ue } from "./cmsConstants-95f19583.mjs";
import { J as L } from "./profileApi-9f951b9e.mjs";
import { i as we } from "./ContactType-95758036.mjs";
import { p as d, k as _, u as de, d as D, l as oe, n as j, f as W, j as h, x as ge, a as z } from "./helper-96ef8cd6.mjs";
import { E as Re, p as Y, l as re, r as fe } from "./Constants-9b601a55.mjs";
import { Y as Ae } from "./cmsTransformer-fa124f69.mjs";
import { cmsApi as De } from "@commerce-webcomponents/sdk";
import { PaymentTransactionStatus as Ee, PaymentEntryType as pe } from "@commerce-payment-webcomponents/sdk";
import { T as X } from "./I18nUtils-f6d3f613.mjs";
import { A as ye } from "./Logger-51340717.mjs";
import { productApi as Se, ProjectionType as Te } from "@commerce-product-webcomponents/sdk";
import { l as me } from "./logObject-9202373b.mjs";
import { g as ee, M as te, b as x } from "./myAccountProfileUtils-36c77762.mjs";
const ie = {
  Started: "STARTED",
  SubmitStarted: "SUBMIT_STARTED",
  MdmsAccountRegistered: "MDMS_ACCOUNT_REGISTERED",
  Completed: "COMPLETED",
  CompletedByAutoRenew: "COMPLETED_BY_AUTO_RENEW",
  CoapplicantInvited: "COAPPLICANT_INVITED",
  ReadyToSendInvitation: "READY_TO_SEND_INVITATION"
}, ce = {
  Full: "FULL",
  Small: "SMALL",
  Documents: "DOCUMENTS"
}, ae = {
  Active: "ACTIVE",
  Inactive: "INACTIVE"
}, K = {
  AlreadyRenewed: "ALREADY_RENEWED",
  CanRenew: "CAN_RENEW",
  MustRenew: "MUST_RENEW",
  CannotRenew: "CANNOT_RENEW"
}, ne = {
  Processing: "PROCESSING",
  None: "NONE",
  Completed: "COMPLETED"
};
var Z = /* @__PURE__ */ ((e) => (e.registrationAttributes = "registrationAttributes", e.registrationAccountType = "registrationAccountType", e.shareCodeAttributes = "sharecodeAttributes", e.accountRenewalAttributes = "accountRenewalAttributes", e.registrationInfoKey = "registrationInfo", e))(Z || {}), q = /* @__PURE__ */ ((e) => (e.HOMEDELIVERY = "homedelivery", e.BOPIS = "bopis", e.SEVEN_ELEVEN = "seveneleven", e.WALKIN = "walkin", e.KERRY = "kerry", e))(q || {});
const He = {
  homedelivery: [
    "homedelivery"
    /* HOMEDELIVERY */
  ],
  bopis: [
    "bopis",
    "seveneleven",
    "walkin",
    "kerry"
    /* KERRY */
  ]
}, Q = {
  responseBody: {
    code: Re.GENERAL_ERROR_CODE
  }
}, Ie = async (e, a, n = ie.Started, t = !1, s = D, r = !1) => {
  try {
    const { registrations: o } = await s(
      () => L.getRegistration({
        accountNumber: parseInt(d(a)),
        status: n,
        ...e && { registrationFlow: e }
      })
    ), [i] = o || [], { registrationId: c = "" } = _(i);
    return de(r, i, c);
  } catch (o) {
    if (t)
      return "";
    throw o ?? Q;
  }
}, he = async (e, a = ce.Small, n = D) => {
  try {
    return await n(
      () => L.getRegistrationDetailsById(e, {}, a)
    );
  } catch {
    return {};
  }
}, Le = async (e, a = D) => {
  try {
    const { registrationId: n = "" } = await a(
      () => L.createRegistrationId({
        registrationFlow: e
      })
    );
    return n;
  } catch (n) {
    throw n != null && n.responseBody ? n : Q;
  }
}, Me = async (e, a = D) => {
  try {
    return await a(() => L.getAccountInformation(e));
  } catch {
    return {
      name: {
        name: ""
      },
      expirationDate: ""
    };
  }
}, se = async (e, a = D) => {
  try {
    const n = await a(() => L.getAccountAutoRenewal(e)), { autoRenewDetails: t } = n, s = (t == null ? void 0 : t.signedUpFlag) ?? !1, r = oe.getSessionStorage(), o = {
      lastUpdate: (/* @__PURE__ */ new Date()).toISOString(),
      autoRenewEnabled: s
    };
    return r.store(Z.accountRenewalAttributes, o), {
      autoRenewEnabled: s,
      autoRenewDetails: t
    };
  } catch {
    return {
      autoRenewEnabled: !1
    };
  }
}, _e = async (e, a = D) => {
  const n = await a(() => L.getAccountByNum(e)), { profileList: t } = n ?? { profileList: [] };
  return t;
}, et = (e, a, n) => {
  var t;
  return a ? (a == null ? void 0 : a.toLowerCase()) === ((t = String(e == null ? void 0 : e.pk)) == null ? void 0 : t.toLowerCase()) ? j.Citizen : j.Foreigner : d(n, j.Citizen);
}, tt = async (e, a, n, t, s = D) => {
  if (n === J.Member) {
    const o = (await _e(e, s)).find((i) => i.primary);
    if ((o == null ? void 0 : o.profileId) === a)
      return t;
    if (o != null && o.profileId) {
      const i = await Ce(o == null ? void 0 : o.profileId, s);
      return d(i == null ? void 0 : i.citizenship);
    }
  }
  return "";
}, Ce = async (e, a = D) => {
  try {
    return await a(() => L.getProfilesById(e));
  } catch {
    return {};
  }
}, at = (e) => e ? H.HORIZONTAL : H.VERTICAL, Oe = {
  allowRenewal: !1,
  renewalConfig: {
    renewalPeriodType: k.EXPIRY_DATE
  },
  allowAutoRenewal: !1,
  allowAutoRenewalCheck: !1,
  allowUpgrade: !1,
  upgradeConfig: {
    validCitizenCountryCode: "",
    upgradeMinAge: 0
  },
  allowDowngrade: !1,
  useProfileCart: !1
}, Ne = (e, a, n, t) => {
  const { allowRenewal: s, renewalConfig: r } = e, { renewalPeriodType: o, showFullDate: i, config: c } = r;
  if (!s || !c)
    return {
      allowRenewal: !1,
      renewalStartDate: new Date(a),
      renewalNudgeStartDate: new Date(a),
      gracePeriodDate: new Date(a),
      isLastGraceMonth: !1,
      formattedRenewalStartDate: "",
      formattedExpiryDate: new Date(a).toISOString(),
      formattedGracePeriodDate: new Date(a).toISOString(),
      isRenewalMonth: !1,
      isExpired: !1,
      showNudgeDuringAutoRenewalMonth: !1
    };
  const w = /* @__PURE__ */ new Date(), R = new Date(d(a)), l = new Date(R);
  l.setDate(1);
  let u = new Date(l);
  const y = new Date(d(a)), C = W(y == null ? void 0 : y.toString(), n, t), f = new Date(R);
  let O = !1;
  const { showNudgeDuringAutoRenewalMonth: B } = c;
  if (o === k.FIXED_MONTH) {
    const { renewalMonthStart: S, renewalMonthEnd: g } = c;
    l.setMonth(h(S) - 1), u.setMonth(h(S) - 1), f.setFullYear(l.getFullYear() + 1), f.setMonth(h(g), 1), f.setDate(0);
  } else if (o === k.EXPIRY_DATE) {
    const { renewalWindowPeriodMonths: S, renewalGracePeriodMonths: g, alertOnLastGraceMonth: E, renewalNudgeBeginMonths: A } = c;
    l.setMonth(l.getMonth() - h(S)), f.setMonth(f.getMonth() + h(g) + 1), f.setDate(0), A ? u.setMonth(u.getMonth() - h(A)) : u = new Date(l), E && f.getMonth() === w.getMonth() && (O = !0);
  }
  const N = W(l.toString(), n, X.SHORT_DATE), F = String(N).slice(-4), U = W(l.toString(), n, X.SHORT_DATE), T = i ? U : `${l.getMonth() + 1}/${F}`, b = W(f.toString(), n, t), v = R.getMonth() === w.getMonth(), m = R.getMonth() < w.getMonth();
  return {
    allowRenewal: s,
    renewalStartDate: l,
    renewalNudgeStartDate: u,
    gracePeriodDate: f,
    isLastGraceMonth: O,
    formattedRenewalStartDate: T,
    formattedExpiryDate: C,
    formattedGracePeriodDate: b,
    isRenewalMonth: v,
    isExpired: m,
    showNudgeDuringAutoRenewalMonth: B
  };
}, be = (e, a, n) => {
  const t = !e || e && e !== ne.Processing, s = !a || a && a !== ne.Completed;
  return !!(n && t && s);
}, ve = ({
  type: e,
  accountExpirationDate: a,
  renewalStatus: n,
  accountStatus: t,
  locale: s,
  dateFormat: r,
  renewalLifecycle: o,
  businessNatureLifeCycle: i,
  lifeCycleConfig: c,
  isAutoRenewalEnabled: w = !1,
  isAutoRenewalFailed: R = !1
}) => {
  const l = /* @__PURE__ */ new Date(), {
    allowRenewal: u,
    renewalStartDate: y,
    renewalNudgeStartDate: C,
    isLastGraceMonth: f,
    formattedRenewalStartDate: O,
    formattedExpiryDate: B,
    formattedGracePeriodDate: N,
    isRenewalMonth: F,
    isExpired: U
  } = Ne(c, a, s, r), { renewalConfig: T } = c, { config: b } = _(T), { allowLateRenew: v } = _(b), m = e === J.BusinessOwner, S = C.getTime() <= l.getTime(), g = y.getTime() <= l.getTime(), E = [K.CanRenew, K.MustRenew].includes(
    d(n)
  ) && t === ae.Active, A = be(o, i, u), M = A && g && E, p = A && S && E, I = A && n === K.MustRenew, G = v && I;
  let V = !1;
  return w ? V = R || I : V = I || p, {
    expiryDate: B,
    rawExpiryDate: a,
    // return original date
    inactiveDate: N,
    renewalStartDate: O,
    mustRenew: I,
    canRenew: M,
    canLateRenew: G,
    canUpgrade: !m && t === ae.Active && A,
    canDowngrade: m && E && A,
    isAutoRenewalEnabled: w,
    isAutoRenewalFailed: R,
    showRenewalNudge: V,
    isABO: m,
    type: e,
    isLastGraceMonth: f && V,
    isRenewalMonth: F,
    isExpired: U
  };
}, nt = async (e, a = D) => {
  var t, s, r;
  const n = {
    title: "",
    description: ""
  };
  try {
    const o = await a(
      () => De.fetchContent({
        uId: ue.ACCOUNT_LIFE_CYCLE
      })
    ), i = Ae(
      o
    );
    let c;
    switch (e) {
      case $.Renewal:
        c = (t = i == null ? void 0 : i.data) == null ? void 0 : t.renewalTermsCondition;
        break;
      case $.Upgrade:
        c = (s = i == null ? void 0 : i.data) == null ? void 0 : s.upgradeTermsCondition;
        break;
      case $.Downgrade:
        c = (r = i == null ? void 0 : i.data) == null ? void 0 : r.downgradeTermsCondition;
        break;
      default:
        c = n;
    }
    return c ?? n;
  } catch {
    return n;
  }
}, Pe = {
  expiryDate: "",
  rawExpiryDate: "",
  inactiveDate: "",
  renewalStartDate: "",
  mustRenew: !1,
  canRenew: !1,
  canLateRenew: !1,
  canUpgrade: !1,
  canDowngrade: !1,
  isAutoRenewalEnabled: !1,
  isAutoRenewalFailed: !1,
  showRenewalNudge: !1,
  isABO: !1,
  type: J.Member
}, st = async (e, a, n, t, s = !1, r = D) => {
  var v, m, S;
  const { aboNum: o } = e, [i] = String(n).split("-");
  let c = Pe;
  if (!o)
    return t == null || t(c), c;
  let w, R, l, u, y, C = "";
  if (s) {
    const { type: g, accountExpirationDate: E, renewalStatus: A, renewalLifecycle: M, accounts: p } = e, I = (v = p == null ? void 0 : p.find(
      (G) => String(G.accountNumber) === String(o)
    )) == null ? void 0 : v.accountStatus;
    w = d(E), R = d(A), l = d(M), u = g, y = I;
  } else {
    const g = await Me(o, r), { accountType: E, expirationDate: A, renewalStatus: M, renewalLifecycle: p, status: I, autoRenewalOrderStatus: G } = _(g);
    w = d(A), l = d(p), R = d(M), u = E, y = I, C = d(G);
  }
  const f = ee(
    a,
    te.STEP_GENERAL_CONFIG
  ), O = (S = (m = f == null ? void 0 : f.dateFormat) == null ? void 0 : m.transformation.find(
    (g) => (g == null ? void 0 : g.siteLocale) === i
  )) == null ? void 0 : S.dateLocale, { inputs: B } = ee(a, te.STEP_ACCOUNT_LIFE_CYCLE), N = Fe(B, u), { allowAutoRenewalCheck: F } = N, U = C === fe;
  let T = !1, b = !1;
  if (F) {
    if (s) {
      const E = oe.getSessionStorage().retrieve(
        Z.accountRenewalAttributes
      ), { lastUpdate: A, autoRenewEnabled: M } = E || {};
      if (A)
        T = !!M, b = !0;
      else {
        const p = await se(o, r);
        T = !!(p != null && p.autoRenewEnabled);
      }
    }
    if (!b) {
      const { autoRenewEnabled: g } = await se(o, r);
      T = !!g;
    }
  }
  return c = ve({
    type: u,
    isAutoRenewalEnabled: T,
    isAutoRenewalFailed: U,
    accountExpirationDate: String(w),
    renewalStatus: R,
    renewalLifecycle: l,
    accountStatus: y,
    locale: O ?? i,
    dateFormat: X.SHORT_DATE,
    lifeCycleConfig: N
  }), t == null || t(c), c;
}, Be = (e) => {
  const a = x(e, Y.RENEWAL_CONFIG);
  return a || {
    visible: !1,
    renewalPeriodType: k.EXPIRY_DATE,
    showFullDate: !1,
    memberType: []
  };
}, Fe = (e, a) => {
  if (!e || e.length === 0)
    return Oe;
  const n = ge(), t = Be(e), s = Array.isArray(t == null ? void 0 : t.memberType) ? t.memberType.find(
    (u) => u.memberType === a && (Array.isArray(u == null ? void 0 : u.env) && u.env.includes(n) || !(u != null && u.env))
  ) : void 0, r = x(e, Y.ALLOW_AUTO_RENEWAL), o = x(e, Y.ALLOW_UPGRADE), { visible: i, validCitizenCountryCode: c, minor: w } = o, R = x(e, Y.ALLOW_DOWNGRADE), l = x(e, Y.USE_PROFILE_CART);
  return {
    allowRenewal: !!(t != null && t.visible),
    // Market specific will override this setting. (eg: MEMBER not allow renew)
    renewalConfig: {
      renewalPeriodType: d(t == null ? void 0 : t.renewalPeriodType),
      showFullDate: !!(t != null && t.showFullDate),
      config: s
    },
    allowAutoRenewal: !!(r != null && r.visible),
    allowAutoRenewalCheck: !!(r != null && r.checkAutoRenewStatus),
    allowUpgrade: !!i,
    upgradeConfig: {
      validCitizenCountryCode: String(c),
      upgradeMinAge: h(w == null ? void 0 : w.min)
    },
    allowDowngrade: !!(R != null && R.visible),
    useProfileCart: !!(l != null && l.value)
  };
}, ot = async (e, a = D) => {
  const n = {
    currency: "",
    totalAmount: 0,
    formattedPrice: ""
  };
  if (!(e != null && e.fee))
    return n;
  try {
    const t = await a(
      () => Se.getProductByIds({
        idList: [d(e == null ? void 0 : e.fee)],
        projections: Te.Detailed
      })
    ), [s] = z(t == null ? void 0 : t.products), [r] = z(s == null ? void 0 : s.items), [o] = z(r == null ? void 0 : r.prices);
    return {
      currency: d(o == null ? void 0 : o.currency),
      totalAmount: h(o == null ? void 0 : o.priceIncludingTax),
      formattedPrice: d(o == null ? void 0 : o.formattedPrice)
    };
  } catch {
    return n;
  }
}, Ue = async (e, a) => {
  let n = a;
  return n || (n = await Ie(
    re.AutoRenewSignUpFlow,
    e,
    ie.Started,
    !0
  )), n ? await he(n, ce.Full) : null;
}, rt = (e, a, n, t, s, r, o) => {
  const i = a ? P.HOME_DELIVERY : P.PICKUP, c = e ? P.EKIT : i, w = c === P.PICKUP ? n : null;
  return {
    subscriptionId: r,
    subscriptionName: o,
    skuAliasId: t,
    subscriptionDeliveryList: [
      {
        deliveryTypeCd: c,
        deliveryChoiceCd: "Y",
        effectiveDate: /* @__PURE__ */ new Date(),
        languageCd: s,
        ...w && { warehouseCd: w }
      }
    ]
  };
}, it = (e) => {
  const { skuAliasId: a, subscriptionDeliveryList: n } = _(e), [t] = _(n), { deliveryTypeCd: s, warehouseCd: r } = _(t);
  return {
    feeSku: a,
    deliveryTypeCd: s,
    warehouseCd: r,
    isEkit: s === P.EKIT,
    deliveryType: s === P.HOME_DELIVERY ? q.HOMEDELIVERY : q.BOPIS,
    serviceLocationId: r
  };
}, ct = async (e, a, n = !1) => {
  const t = ye.getInstance(me("accountLifeCycleUtils.ts", "autoRenewalStartProcess"));
  try {
    let s = null;
    return n && a && (s = await Ue(e, a)), s || {
      registrationId: await Le(re.AutoRenewSignUpFlow)
    };
  } catch (s) {
    throw t.error("Error while starting registration process", s), s != null && s.responseBody ? s : Q;
  }
}, lt = async (e, a = D) => {
  const n = await a(() => L.getProfileAddress({ ownerId: e, isDefault: !0 }));
  if (n) {
    const { contacts: t } = n;
    return t == null ? void 0 : t.find((s) => s.isDefault && s.contactType === we.Mailing);
  } else
    return null;
}, ut = (e) => {
  var n, t, s;
  if (!e || e.status !== le.INITIATED || !((n = e.transactions) != null && n.length))
    return !1;
  const [a] = e.transactions;
  return !a || a.status !== Ee.Initiated || !((t = a.entries) != null && t.length) ? !1 : ((s = a.entries[0]) == null ? void 0 : s.entryType) === pe.Initiate;
};
export {
  ct as A,
  lt as B,
  ut as C,
  q as E,
  ne as I,
  He as R,
  K as _,
  Ie as a,
  ie as b,
  st as c,
  at as d,
  Fe as e,
  Me as f,
  nt as g,
  Z as h,
  Pe as i,
  Le as j,
  et as k,
  tt as l,
  se as m,
  Q as n,
  he as o,
  ve as p,
  _e as q,
  ce as r,
  Ce as s,
  Ne as t,
  be as u,
  Be as v,
  ot as w,
  Ue as x,
  rt as y,
  it as z
};
//# sourceMappingURL=accountLifeCycleUtils-05e1ad2a.mjs.map
